<template lang="pug">
#app.designer
	nav
		bunt-link-button(:to="{name: 'form'}") back to form
		.right
			bunt-button(@click="$store.dispatch('resetQuestionnaire')") reset to source
			bunt-button(@click="handleExport") export
	.editor
		graph
		node-settings
</template>
<script>
import { mapGetters } from 'vuex'
import Graph from './graph'
import NodeSettings from './node-settings'
export default {
	components: { Graph, NodeSettings },
	data () {
		return {
		}
	},
	computed: {
		...mapGetters(['serializedQuestionnaire'])
	},
	created () {},
	mounted () {
		this.$nextTick(() => {
		})
	},
	methods: {
		handleExport () {
			console.log(this.serializedQuestionnaire)
			navigator.clipboard.writeText(this.serializedQuestionnaire).then(() => {
				window.alert('Copied to clipboard')
			})
		}
	}
}
</script>
<style lang="stylus">
.designer
	display: flex
	flex-direction: column
	nav
		card()
		height: 48px
		padding: 0 16px
		display: flex
		align-items: center
		justify-content: space-between
		flex: none
		z-index: 100
	.editor
		display: flex
</style>
